import React, { useState } from "react";
import SharedHelmet from "../Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds , MobileUnderCalAds } from "../../Ads";
import MainCalculatorsList from "./MainCalculators";
const TITLE = "محول الأرقام إلى كلمات";
const DESCRIPTION = "قم بتحويل الأرقام إلى كلمات باللغة العربية والإنجليزية.";
const KEYWORDS = "تحويل الأرقام, اللغة العربية, اللغة الإنجليزية";
const OG_URL = "https://do-calculate.com/calculator/ar/numbers-to-words/";
const arabicToEnglish = (arabicNum) => {
  const arabicNumbers = "٠١٢٣٤٥٦٧٨٩";
  const englishNumbers = "0123456789";
  return arabicNum
    .split("")
    .map((char) =>
      arabicNumbers.indexOf(char) !== -1
        ? englishNumbers[arabicNumbers.indexOf(char)]
        : char
    )
    .join("");
};
const units = [
  "",
  "one",
  "two",
  "three",
  "four",
  "five",
  "six",
  "seven",
  "eight",
  "nine",
  "ten",
  "eleven",
  "twelve",
  "thirteen",
  "fourteen",
  "fifteen",
  "sixteen",
  "seventeen",
  "eighteen",
  "nineteen",
];
const tens = [
  "",
  "",
  "twenty",
  "thirty",
  "forty",
  "fifty",
  "sixty",
  "seventy",
  "eighty",
  "ninety",
];
const scales = [
  "",
  "thousand",
  "million",
  "billion",
  "trillion",
  "quadrillion",
  "quintillion",
  "sextillion",
  "septillion",
  "octillion",
  "nonillion",
  "decillion",
  "undecillion",
  "duodecillion",
  "tredecillion",
  "quattuordecillion",
  "quindecillion",
  "sexdecillion",
  "septendecillion",
  "octodecillion",
  "novemdecillion",
  "vigintillion",
];
function convertToWords(num) {
  if (num === 0) return "zero";
  if (num < 20) return units[num];
  if (num < 100)
    return tens[Math.floor(num / 10)] + (num % 10 ? "-" + units[num % 10] : "");
  let word = "";
  let scaleIndex = 0;
  while (num > 0) {
    const n = num % 1000;
    if (n !== 0) {
      let str = "";
      if (n < 100) {
        str = convertToWords(n);
      } else {
        str =
          units[Math.floor(n / 100)] +
          " hundred" +
          (n % 100 !== 0 ? " and " + convertToWords(n % 100) : "");
      }
      word = str + " " + scales[scaleIndex] + " " + word;
    }
    num = Math.floor(num / 1000);
    scaleIndex++;
  }
  return word.trim();
}
function convertToArabicWords(num) {
  if (num === 0) return "صفر";
  const arabicUnits = [
    "",
    "واحد",
    "اثنان",
    "ثلاثة",
    "أربعة",
    "خمسة",
    "ستة",
    "سبعة",
    "ثمانية",
    "تسعة",
  ];
  const arabicTens = [
    "",
    "عشرة",
    "عشرون",
    "ثلاثون",
    "أربعون",
    "خمسون",
    "ستون",
    "سبعون",
    "ثمانون",
    "تسعون",
  ];
  const arabicTeens = [
    "",
    "أحد عشر",
    "اثنا عشر",
    "ثلاثة عشر",
    "أربعة عشر",
    "خمسة عشر",
    "ستة عشر",
    "سبعة عشر",
    "ثمانية عشر",
    "تسعة عشر",
  ];
  const arabicHundreds = [
    "",
    "مئة",
    "مئتان",
    "ثلاثمئة",
    "أربعمئة",
    "خمسمئة",
    "ستمئة",
    "سبعمئة",
    "ثمانمئة",
    "تسعمئة",
  ];
  const arabicScales = [
    "",
    "ألف",
    "مليون",
    "مليار",
    "تريليون",
    "كوادريليون",
    "كوينتليون",
    "سكستليون",
    "سبتيليون",
    "أوكتيليون",
    "نونليون",
    "ديكيليون",
  ];
  let word = "";
  let scaleIndex = 0;
  while (num > 0) {
    const n = num % 1000;
    if (n !== 0) {
      let str = "";
      const hundreds = Math.floor(n / 100);
      const remainder = n % 100;
      if (hundreds) {
        str += arabicHundreds[hundreds];
      }
      if (remainder > 0 && remainder < 20) {
        if (remainder < 10) {
          str += (hundreds ? " و " : "") + arabicUnits[remainder];
        } else {
          str += (hundreds ? " و " : "") + arabicTeens[remainder - 10];
        }
      } else if (remainder >= 20) {
        const tens = Math.floor(remainder / 10);
        const units = remainder % 10;
        if (units) {
          str +=
            (hundreds ? " و " : "") +
            arabicUnits[units] +
            " و " +
            arabicTens[tens];
        } else {
          str += (hundreds ? " و " : "") + arabicTens[tens];
        }
      }
      if (scaleIndex > 0) {
        str += " " + arabicScales[scaleIndex];
      }
      word = str + (word ? " و " : "") + word;
    }
    num = Math.floor(num / 1000);
    scaleIndex++;
  }
  return word.trim();
}
function Example() {
  const [inputValue, setInputValue] = useState("");
  const [result, setResult] = useState();
  const [arabicResult, setArabicResult] = useState();
  const [error, setError] = useState("");
  const handleCalculate = () => {
    try {
      const number = parseInt(arabicToEnglish(inputValue));
      if (!isNaN(number)) {
        setResult(convertToWords(number));
        setArabicResult(convertToArabicWords(number));
      } else {
        setError("يرجى إدخال رقم صحيح");
      }
    } catch (error) {
      setError(error.message);
    }
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>تقوم هذه الحاسبة بتحويل الأرقام إلى كلمات.</p>
                <p>
                  أدخل الرقم المراد تحويله إلى كلمة وسيتم عرضه باللغتين العربية
                  والإنجليزية:
                </p>
                <hr />
              </div>
              <br />
            </div>
             <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div dir="rtl">
                  <div>
                    <hr />
                    <div
                      className="form-group d-flex align-items-center"
                      htmlFor="inputValue"
                    >
                      <b>
                        <label className="form-label ms-2">أدخل الرقم</label>
                      </b>
                      <input
                        id="inputValue"
                        type="text"
                        value={inputValue}
                        onChange={(e) => setInputValue(e.target.value)}
                        placeholder="أدخل الرقم"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px", marginLeft: "10px" }}
                      onClick={handleCalculate}
                    >
                      احسب                    </button>
                  </div>
                  <br />
                  { error !== "" && (
                    <p className="p-3 mb-2 bg-warning text-black">
                      خطأ: {error}
                    </p>
                  )}
                  {result &&  (
                    <div className="p-3 mb-2 bg-success text-white">
                      <h4>النتيجة بالإنجليزية:</h4>
                      <p className="text-white">{result}</p>
                      <h4>النتيجة بالعربية:</h4>
                      <p className="text-white">{arabicResult}</p>
                    </div>
                  )}
                  <hr />
                </div>
              </div>
            </div>
            <hr />            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">معلومات حول تحويل الأرقام</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      ما هي أهمية تحويل الأرقام إلى كلمات؟
                    </h2>{" "}
                  </u>
                  <p>
                    تحويل الأرقام إلى كلمات يعد من الأمور الضرورية في العديد من
                    المجالات، مثل كتابة الشيكات، والفواتير، والعقود.
                  </p>
                  <p>
                    يساعد هذا التحويل على تجنب الأخطاء في كتابة الأرقام بشكل
                    خاطئ ويعزز من دقة العمليات الحسابية.
                  </p>
                  <p>
                    يمكن أن يسهم أيضاً في تسهيل عملية التوثيق والتسجيل في الأمور
                    المالية والقانونية.
                  </p>
                  <div className="p-3 mb-2 bg-info  ">
                    على سبيل المثال، يمكن تحويل الرقم 123 إلى "مئة وثلاثة
                    وعشرون".
                  </div>
                  <br />
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>كيفية استخدام الحاسبة</h2>{" "}
                  </u>
                  <p>لاستخدام هذه الحاسبة، اتبع الخطوات التالية:</p>
                  <ul>
                    <li>أدخل الرقم الذي ترغب في تحويله في الحقل المخصص.</li>
                    <li>اضغط على زر "تحويل" للحصول على النتيجة.</li>
                  </ul>
                  <p>ستظهر النتيجة بالكلمات باللغة العربية والإنجليزية.</p>
                  <div className="p-3 mb-2 bg-info text-black ">
                    على سبيل المثال: إدخال الرقم 45 سيعطيك النتيجة "خمسة
                    وأربعون" باللغة العربية و "forty-five" باللغة الإنجليزية.
                  </div>
                  <hr />
                </div>
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>الأسئلة الشائعة</h2>{" "}
                  </u>
                  <p>فيما يلي بعض الأسئلة الشائعة حول الحاسبة:</p>
                  <ul>
                    <li>ما هو الحد الأقصى للأرقام التي يمكن تحويلها؟</li>
                    <li>هل تدعم الحاسبة الأرقام العشرية؟</li>
                  </ul>
                  <p>
                    الإجابة على هذه الأسئلة تعتمد على الإصدار الحالي للحاسبة.
                  </p>
                  <b>مثال:</b>
                  <div className="p-3 mb-2 bg-info text-black ">
                    الحاسبة الحالية تدعم تحويل الأرقام الصحيحة فقط ولا تدعم
                    الأرقام العشرية.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default Example;
